import { frontendURL } from 'dashboard/helper/URLHelper';
import AttendanceDirectivesIndex from './pages/AttendanceDirectivesIndex.vue';

const attendanceDirectivesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/attendance-directives'),
      name: 'attendance_directives_index',
      meta: {
        permissions: ['administrator'],
      },
      component: AttendanceDirectivesIndex,
    },
  ],
};

export default attendanceDirectivesRoutes;
